import { Button } from "@sidelinesports/fan-design-system";
import { Dialog } from "../../../../components/index.tsx";
import {
  useCurrentGameId,
  useCurrentGameQuery,
} from "../../hooks/use-current-game.ts";
import { useCurrentScoringAndRank } from "../../hooks/use-current-scoring-and-rank.ts";
import { PostGameMessage } from "./PostGameMessage.tsx";

export const PostGameMessageButton = () => {
  const _currentGameId = useCurrentGameId();
  const currentGameQuery = useCurrentGameQuery();
  const scoringQuery = useCurrentScoringAndRank();

  if (currentGameQuery.isPending || scoringQuery.isPending) {
    return null;
  }

  if (currentGameQuery.isError || scoringQuery.isError) {
    return null;
  }

  const game = currentGameQuery.data;

  if (game.status !== "finished" || scoringQuery.data.rank.rank === null) {
    return null;
  }

  return (
    <PostGameMessage
      game={game}
      position={scoringQuery.data.rank.rank}
      trigger={<Dialog.Trigger as={Button}>View Results</Dialog.Trigger>}
    />
  );
};
